class SliderManager {
    constructor() {
        // Initialisiert alle vordefinierten Slider
        this.initHomeHeroSlider();
        this.initTapeColorsSlider();
        this.initKTapeOriginalSlider();
        this.initKTapeTeamSlider();
    }

    // Home Hero Slider
    initHomeHeroSlider() {
        $('#home-hero').on('init', (event, slick) => {
            // Führe hier zusätzliche Aktionen aus, wenn der Slider initialisiert wurde
            this.updateImages();
        });

        $('#home-hero').slick({
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: false,
            fade: true,
            cssEase: 'linear',
            infinite: true,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 750,
                    settings: {
                        fade: false,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        // Stelle sicher, dass die Bilder beim Resize-Event aktualisiert werden
        window.addEventListener('resize', this.updateImages);
    }

    // Farben-Slider
    initTapeColorsSlider() {
        $('#home-tape-colors').slick({
            slidesToShow: 10,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 990,
                    settings: {
                        arrows: false,
                        slidesToShow: 6
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    // K-Tape Original Slider
    initKTapeOriginalSlider() {
        $('#home-k-tape-original').slick({
            slidesToShow: 3,
            autoplay: true,
            autoplaySpeed: 2000,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    // K-Tape Team Slider
    initKTapeTeamSlider() {
        $('#k-tape-team-slider').slick({
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 10000,
            arrows: false,
            dots: false,
            fade: true,
            cssEase: 'linear',
            infinite: true,
            pauseOnHover: false,
        });
    }

    // Aktualisiert die Bilder für den Home Hero Slider
    updateImages() {
        let images = document.querySelectorAll('.hero-slide > img');
        let windowWidth = window.innerWidth;

        images.forEach((image) => {
            let largeImage = image.getAttribute('data-large');
            let smallImage = image.getAttribute('data-small');

            if (windowWidth < 750) {
                image.src = smallImage;
            } else {
                image.src = largeImage;
            }

            image.onload = function () {
                image.classList.add('image-loaded');
            };
        });
    }
}